import getCSRReceiptStore from "../../stores/csr-store/csr-receipt-event-count";

const getCurrentMonthCalculatedObject = () => {
  const supervisorCompensation =
    getCSRReceiptStore().currentMonthCSRReceipt.get();
  return {
    descriptionPricing: supervisorCompensation.description.price,
    descriptionDiscount: supervisorCompensation.description.discount,
    picturePricing: supervisorCompensation.picture.price,
    pictureDiscount: supervisorCompensation.picture.discount,
    reportPricing: supervisorCompensation.report.price,
    reportDiscount: supervisorCompensation.report.discount,
    investigationCasesPricing: supervisorCompensation.investigationCases.price,
    investigationCasesDiscount:
      supervisorCompensation.investigationCases.discount
  };
};

export const currentMonthCSRArray = () => {
  return [
    {
      id: 0,
      finalSalary: getCSRReceiptStore().finalSalary.get(),
      ...getCurrentMonthCalculatedObject()
    }
  ];
};
